


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import './DrawerContainer.css';
// import Initiatives from './Initiatives';
// import {
//   MdHome, MdPublic, MdDomain, MdInfo, MdGroup, MdPerson,
//   MdAttachMoney, MdMenuBook, MdList, MdEvent, MdCall,
//   MdLogout, MdKeyboardArrowDown, MdKeyboardArrowUp
// } from 'react-icons/md';
// import { CgProfile } from "react-icons/cg";
// import Llogo from '../img/Llogo.png';
// import { FaBell, FaCamera, FaHome, FaImages } from 'react-icons/fa';

// export default function HomeScreen() {
//   const navigate = useNavigate();
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [expandedMenu, setExpandedMenu] = useState(null);
//   const [selectedSubmenu, setSelectedSubmenu] = useState([]);

//   const previewContainerStyle = {
//     width: '375px',
//     maxHeight: '667px',
//     margin: '10px auto',
//     border: '1px solid #ccc',
//     borderRadius: '20px',
//     overflow: 'hidden',
//     boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//     backgroundColor: '#f8f9fa',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'space-between',
//     position: 'relative'
//   };

//   const menuItems = [
//     { id: 1, item_name: 'Home' },
//     { id: 2, item_name: 'International' },
//     { id: 3, item_name: 'District' },
//     { id: 4, item_name: 'Multiple Information' },
//     { id: 5, item_name: 'Club' },
//     { id: 6, item_name: 'Member' },
//     { id: 7, item_name: 'Dollar Rate' },
//     { id: 8, item_name: 'DG Diary' },
//     { id: 9, item_name: 'BAMA List' },
//     { id: 10, item_name: 'Events' },
//     { id: 11, item_name: 'Contact' }
//   ];

//   const iconMap = {
//     Home: <MdHome />, International: <MdPublic />, District: <MdDomain />,
//     'Multiple Information': <MdInfo />, Club: <MdGroup />, Member: <MdPerson />,
//     'Dollar Rate': <MdAttachMoney />, 'DG Diary': <MdMenuBook />,
//     'BAMA List': <MdList />, Events: <MdEvent />, Contact: <MdCall />
//   };

//   const fetchSubmenu = async (type) => {
//     try {
//       const url = type === 'International'
//         ? 'https://lionsdirectoryapi.emedha.in/international/menu/get'
//         : 'https://lionsdirectoryapi.emedha.in/district/menu/get';
//       const { data } = await axios.post(url);
//       setSelectedSubmenu(data);
//       setExpandedMenu(type);
//     } catch (err) {
//       console.error('Error fetching submenu:', err);
//     }
//   };

//   const handleMenuClick = (item) => {
//     if (item.item_name === 'International' || item.item_name === 'District') {
//       if (expandedMenu === item.item_name) {
//         setExpandedMenu(null);
//         setSelectedSubmenu([]);
//       } else {
//         fetchSubmenu(item.item_name);
//       }
//     } else {
//       navigate(`/${item.item_name.toLowerCase().replace(/ /g, '-')}`);
//       setExpandedMenu(null);
//       setSelectedSubmenu([]);
//     }
//   };

//   return (

//       <div style={previewContainerStyle}>
//      <div className="navbar1">
//   <img
//     src={Llogo}
//     alt="Logo"
//     style={{ width: '50px', height: 50, cursor: 'pointer' }}
//     onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//   />

//   <h3 style={{ color: '#fff', margin: 0 }}>Lions Club</h3>

//     <CgProfile
//       color="#FFD700"
//       size={28}
//       style={{ cursor: 'pointer' }}
//       onClick={() => navigate('/profile')}
//       aria-label="Profile"
//       title="Profile"
//     />
// </div>


//         {isSidebarOpen && (
//           <div className="sidebar">
//             <ul className="menu-list">
//               {menuItems.map(item => (
//                 <li key={item.id}>
//                   <div className="menu-item" onClick={() => handleMenuClick(item)}>
//                     <span className="icon">{iconMap[item.item_name]}</span>
//                     <span>{item.item_name}</span>
//                     {(item.item_name === 'International' || item.item_name === 'District') && (
//                       <span className="arrow">
//                         {expandedMenu === item.item_name ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
//                       </span>
//                     )}
//                   </div>
//                   {expandedMenu === item.item_name && selectedSubmenu.length > 0 && (
//                     <ul className="submenu-list">
//                       {selectedSubmenu.map((sub, idx) => (
//                         <li key={idx} className="submenu-item" onClick={() => navigate(`/${sub.route}`)}>
//                           {sub.name}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </li>
//               ))}
//             </ul>
//             <button className="logout-button" onClick={() => navigate('/login')}>
//               <MdLogout /> Logout
//             </button>
//           </div>
//         )}

//         <div style={{ flex: 1, overflowY: 'auto' }}>
//           <Initiatives />
//         </div>

//         <div className="footer">
//          <FaHome size={24} style={{ cursor: 'pointer',color:'#fff' }} onClick={() => navigate('/')} aria-label="Home" />
//       <FaBell size={24} style={{ cursor: 'pointer',color:'#fff' }} onClick={() => navigate('/notifications')} aria-label="Notifications" />
//       <FaCamera CgProfile size={24} style={{ cursor: 'pointer',color:'#fff' }} onClick={() => navigate('/camera')} aria-label="Camera" />
//       <FaImages size={24} style={{ cursor: 'pointer' ,color:'#fff'}} onClick={() => navigate('/gallery')} aria-label="Gallery" />
//         </div>
//       </div>
    
//   );
// }


import React from 'react';
// Note: You can replace these with your own SVG icons or any icon library
import { 
  Users, User, Building2, Info, CircleDollarSign, 
  BookOpen, List, Calendar, Phone, Bell, 
  Home, Camera, Image, CheckSquare ,ChevronLeft, 
  Globe
} from 'lucide-react';
import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import ClubsList from './ClubWeb';
import ClubDetails from './ClubDetails';
import MembersList from './MemberWeb';
import DistrictList from './District';
import DistrictMembers from './DistrictMembers';
import BAMAList from './BamaWeb';
import ProfilePage from './ProfilePage';
import MultipleDgWeb from './MultipleDgWeb';
import DollarRate from './DollarRate';
import DGDiaryWeb from './DGDiaryWeb';
import EventsWeb from './EventsWeb';
import ContactWeb from './ContactWeb';
import NotificationWeb from './NotificationWeb';
import ActivityGallery from './GalleryWeb';
import GalleryDetail from './GalleryDetail';
import CameraView from './CameraView';
import ActivityDetails from './ActivityDetails';
import { Global } from '@emotion/react';
import InternationalMembers from './InternationalMembers';
import InternationaltList from './International';


const AuthScreen = ({
  view,
  setView,
  mobileNumber,
  setMobileNumber,
  otp,
  setOtp,
  handleSendOTP,
  handleVerifyOTP,
    loadingSendOtp,
  loadingVerifyOtp,
  resendTimer,
  styles
}) => {

  const isMobileStep = view === 'LOGIN';
  const isOtpStep = view === 'VERIFY';

  return (
    <div style={{ ...styles.scrollArea, padding: '20px', textAlign: 'center' }}>
      
      {/* Back Button */}
      <div
        onClick={() => setView('HOME')}
        style={{
          display: 'flex',
          alignItems: 'center',
          color: '#0033A0',
          cursor: 'pointer',
          marginBottom: '20px'
        }}
      >
        <span style={{ fontSize: '20px', marginRight: '5px' }}>←</span> Back
      </div>

      {/* Icon Circle */}
      <div
        style={{
          backgroundColor: '#0033A0',
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          margin: '0 auto 20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white'
        }}
      >
        {isMobileStep ? (
          <span style={{ fontSize: '40px' }}>📱</span>
        ) : (
          <span style={{ fontSize: '40px' }}>🛡️</span>
        )}
      </div>

      {/* Title */}
      <h2 style={{ color: '#0033A0', marginBottom: '10px' }}>
        {isMobileStep ? 'Welcome Back' : 'Verify OTP'}
      </h2>

      <p style={{ color: '#666', fontSize: '14px', marginBottom: '30px' }}>
        {isMobileStep
          ? 'Enter your mobile number to receive an OTP'
          : `We've sent a verification code to ${mobileNumber}`}
      </p>

      {/* Input */}
      <div style={{ textAlign: 'left', marginBottom: '20px' }}>
        <label
          style={{
            display: 'block',
            fontSize: '14px',
            marginBottom: '8px',
            fontWeight: '500'
          }}
        >
          {isMobileStep ? 'Mobile Number' : 'Enter OTP'}
        </label>

        <input
          type="text"
          placeholder={
            isMobileStep ? 'Enter Mobile Number' : 'Enter 6-digit OTP'
          }
          value={isMobileStep ? mobileNumber : otp}
          onChange={(e) =>
            isMobileStep
              ? setMobileNumber(e.target.value)
              : setOtp(e.target.value)
          }
          style={{
            width: '100%',
            padding: '15px',
            borderRadius: '10px',
            border: '2px solid #0033A0',
            boxSizing: 'border-box',
            fontSize: '16px'
          }}
        />

        <p style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
          {isMobileStep
            ? 'Enter your registered mobile number'
            : 'Code expires in 55 seconds'}
        </p>
      </div>

      {/* Button */}
  <button
  onClick={isMobileStep ? handleSendOTP : handleVerifyOTP}
  disabled={loadingSendOtp || loadingVerifyOtp}
  style={{
    width: '100%',
    backgroundColor: '#FFC20E',
    border: 'none',
    padding: '15px',
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: '16px',
    cursor: 'pointer',
    opacity: (loadingSendOtp || loadingVerifyOtp) ? 0.7 : 1
  }}
>
  {isMobileStep
    ? (loadingSendOtp ? 'Sending...' : 'Send OTP')
    : (loadingVerifyOtp ? 'Verifying...' : 'Verify OTP')}
</button>

      {/* Footer Text */}
      {isMobileStep ? (
        <p style={{ fontSize: '12px', color: '#888', marginTop: '20px' }}>
          You will receive a one-time password via SMS
        </p>
      ) : (
        <div style={{ marginTop: '20px' }}>
         {resendTimer > 0 ? (
  <p style={{ color: '#0033A0', fontSize: '14px' }}>
    Resend OTP in {resendTimer}s
  </p>
) : (
  <p
    onClick={handleSendOTP}
    style={{
      color: '#0033A0',
      fontSize: '14px',
      fontWeight: 'bold',
      cursor: 'pointer'
    }}
  >
    Resend OTP
  </p>
)}
          <p
            onClick={() => setView('LOGIN')}
            style={{
              color: '#0033A0',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Change mobile number
          </p>
        </div>
      )}
    </div>
  );
};


const HomeScreen = () => {
  // --- Inline Style Objects ---
  const styles = {
    container: {
       width: '375px',
  minHeight: '667px', // iPhone 8/SE 2nd Gen height
  margin: '10px auto',
  border: '1px solid #ccc',
  borderRadius: '20px',
  overflow: 'hidden',
  boxShadow: '0 0 10px rgba(0,0,0,0.2)',
  backgroundColor: '#f8f9fa', // Optional for visual clarity
  display: 'flex',
  flexDirection: 'column',
 
    },
    header: {
      backgroundColor: '#0033A0',
      color: 'white',
      padding: '12px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logoSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    logoCircle: {
      backgroundColor: 'white',
      color: '#0033A0',
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '18px',
    },
    scrollArea: {
      flex: 1,
      overflowY: 'auto',
      paddingBottom: '80px', // Space for bottom nav
    },
    banner: {
      backgroundColor: '#FFC20E',
      margin: '16px',
      padding: '30px 20px',
      borderRadius: '16px',
      textAlign: 'center',
      position: 'relative',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    },
    bannerTitle: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#333',
      margin: '0 0 8px 0',
    },
    bannerSub: {
      fontSize: '14px',
      color: '#555',
    },
    dotsContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '6px',
      marginTop: '20px',
    },
    dot: {
      height: '6px',
      borderRadius: '10px',
      backgroundColor: 'white',
    },
    quickAccessTitle: {
      color: '#0033A0',
      fontWeight: 'bold',
      padding: '0 16px',
      marginBottom: '12px',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '12px',
      padding: '0 16px',
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      border: '1px solid #eee',
      padding: '24px 12px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
    },
    iconCircle: {
      backgroundColor: '#E8EEFB',
      color: '#0033A0',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardLabel: {
      fontSize: '13px',
      fontWeight: '500',
      color: '#444',
    },
    bottomNav: {
      position: 'fixed',
      bottom: 0,
      width: '375px',
      backgroundColor: 'white',
      borderTop: '2px solid #FFC20E',
      display: 'flex',
      justifyContent: 'space-around',
      padding: '8px 0',
      boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
    },
    navItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '11px',
      fontWeight: 'bold',
      color: '#888',
      gap: '4px',
    }
  };

   const [view, setView] = useState('HOME'); // HOME | LOGIN | VERIFY
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');

const [loadingSendOtp, setLoadingSendOtp] = useState(false);
const [loadingVerifyOtp, setLoadingVerifyOtp] = useState(false);
const [resendTimer, setResendTimer] = useState(0)
const [selectedCategory, setSelectedCategory] = useState('');
const [selectedImage, setSelectedImage] = useState(null);;
const [capturedImage, setCapturedImage] = useState(null);

  const [current, setCurrent] = useState(0);

  const [selectedClub, setSelectedClub] = useState(null);

   /* ---------------- SESSION CHECK ---------------- */
  const handleProtectedClick = (title) => {
    const isLoggedIn = sessionStorage.getItem('loginMobile');
    const protectedItems = ['Club', 'Member', 'District'];

    if (protectedItems.includes(title) && !isLoggedIn) {
      setView('LOGIN');
    }else if (title === 'Club') {
    setView('CLUBS');
    }
     else if (title === 'Member') {
    setView('MEMBERS_CLUBS'); // First select a club to see its members
  }  else if (title === 'District') {
    setView('DISTRICT_LIST');
  }  else if (title === 'BAMA List') {
    setView('BAMA_LIST');
  } else if (title === 'Multiple Info'){
    setView("MultipleDgWeb")
  } else   if (title === 'Dollar Rate') {
    setView('DOLLAR_RATE');
  } else if (title === 'DG Diary') {
    setView('DG_DIARY');
  }
   else if (title === 'Events') {
    setView('EVENTS');
  } else   if (title === 'Contact') {
    setView('CONTACT');
  } else   if (title === 'Notifications') {
    setView('NOTIFICATIONS');
  } else if(title==="Camera"){
     setView('CAMERA');
  }else if(title==="International"){
   setView("International_LIST")
  }


    
    else {
      console.log('Navigate to', title);
    }
  };

  
  /* ---------------- OTP FLOW ---------------- */
const handleSendOTP = async () => {
  if (!mobileNumber) {
    alert('Please enter mobile number');
    return;
  }

  try {
    setLoadingSendOtp(true);

    const dist = sessionStorage.getItem("dist");

    const res = await axios.post(
      'https://lionsdirectoryapi.emedha.in/api/send-whatsapp-otp',
      {
        mobile: mobileNumber,
        dist: dist
      }
    );

    alert(res.data.message);

    if (res.data.success) {
      setView('VERIFY');
      setResendTimer(60); // start countdown
    }

  } catch (err) {
    if (err.response?.data?.message) {
      alert(err.response.data.message);
    } else {
      alert('Something went wrong while sending OTP');
    }
  } finally {
    setLoadingSendOtp(false);
  }
};


const handleVerifyOTP = async () => {
  if (!otp) {
    alert('Please enter OTP');
    return;
  }

  try {
    setLoadingVerifyOtp(true);

    const dist = sessionStorage.getItem("dist");

    const res = await axios.post(
      'https://lionsdirectoryapi.emedha.in/api/verify-whatsapp-otp',
      {
        mobile: mobileNumber,
        otp: otp,
        dist: dist
      }
    );

    if (res.data.success) {
      const token = "hardcoded_token_123456789";

      sessionStorage.setItem('userToken', token);
      sessionStorage.setItem('loginMobile', mobileNumber);

      alert("Login successful");

      setOtp('');
      setResendTimer(0);
      setView('HOME');
    } else {
      alert(res.data.message);
    }

  } catch (err) {
    console.log(err);
    alert('Error verifying OTP');
  } finally {
    setLoadingVerifyOtp(false);
  }
};

useEffect(() => {
  let interval;

  if (resendTimer > 0) {
    interval = setInterval(() => {
      setResendTimer((prev) => prev - 1);
    }, 1000);
  }

  return () => clearInterval(interval);
}, [resendTimer]);

  useEffect(() => {
  const interval = setInterval(() => {
    setCurrent((prev) => (prev + 1) % banners.length);
  }, 3000);

  return () => clearInterval(interval);
}, []);


const nextSlide = () => {
  setCurrent((prev) => (prev + 1) % banners.length);
};

const prevSlide = () => {
  setCurrent((prev) =>
    prev === 0 ? banners.length - 1 : prev - 1
  );
};

  const banners = [
  {
    title: "Upcoming Events",
    sub: "Join us for our annual charity gala",
    bg: "#FFC20E", // Yellow
    textColor: "#333",
  },
  {
    title: "Make a Difference",
    sub: "Together we can change the world",
    bg: "#0033A0", // Blue
    textColor: "#ffffff",
  },
  {
    title: "Welcome to Lions Club",
    sub: "Serving communities worldwide since 1917",
    bg: "#1E4DB7",
    textColor: "#ffffff",
  },
];

  const menuItems = [
      { title: 'International', icon: <Globe size={28} /> },
        { title: 'Multiple Info', icon: <Info size={28} /> },
    { title: 'District', icon: <Building2 size={28} /> },
  
    { title: 'Club', icon: <Users size={28} /> },
    { title: 'Member', icon: <User size={28} /> },
   
    { title: 'Dollar Rate', icon: <CircleDollarSign size={28} /> },
    { title: 'DG Diary', icon: <BookOpen size={28} /> },
    { title: 'BAMA List', icon: <List size={28} /> },
    { title: 'Events', icon: <Calendar size={28} /> },

    { title: 'Contact', icon: <Phone size={28} /> },

  ];


const handleUpload = async (formValues) => {
  try {
    const formData = new FormData();
    formData.append("file", capturedImage);
    formData.append("dist", sessionStorage.getItem("dist"));
    formData.append("title", formValues.title);
    formData.append("description", formValues.description);
    formData.append("club", formValues.club);
    formData.append("category", formValues.category);

    await axios.post(
      "https://lionsdirectoryapi.emedha.in/uploadGallery-320e",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    alert("Uploaded successfully");
    setView("HOME");
  } catch (err) {
    console.error(err);
    alert("Upload failed");
  }
};


    /* ---------------- HOME VIEW ---------------- */
  const HomeView = () => (
    <>
          {/* Content */}
      <div style={styles.scrollArea}>
        {/* Banner */}
    {/* Banner Slider */}
<div
  style={{
    ...styles.banner,
    backgroundColor: banners[current].bg,
    color: banners[current].textColor,
  }}
>
  {/* Left Arrow */}
  <div
    onClick={prevSlide}
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      fontSize: "20px",
      fontWeight: "bold",
    }}
  >
    ‹
  </div>

  {/* Content */}
  <h2
    style={{
      ...styles.bannerTitle,
      color: banners[current].textColor,
    }}
  >
    {banners[current].title}
  </h2>
  <p
    style={{
      ...styles.bannerSub,
      color: banners[current].textColor,
    }}
  >
    {banners[current].sub}
  </p>

  {/* Right Arrow */}
  <div
    onClick={nextSlide}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      fontSize: "20px",
      fontWeight: "bold",
    }}
  >
    ›
  </div>

  {/* Dots */}
  <div style={styles.dotsContainer}>
    {banners.map((_, index) => (
      <div
        key={index}
        style={{
          ...styles.dot,
          width: current === index ? "20px" : "6px",
          opacity: current === index ? 1 : 0.5,
        }}
      />
    ))}
  </div>
</div>

        {/* Grid Section */}
        <h3 style={styles.quickAccessTitle}>Quick Access</h3>
        <div style={styles.grid}>
          {menuItems.map((item, idx) => (
            <div key={idx} style={styles.card}    onClick={() => handleProtectedClick(item.title)}>
              <div style={styles.iconCircle}>{item.icon}</div>
              <span style={styles.cardLabel}>{item.title}</span>
            </div>
          ))}
        </div>
      </div>

    
    </>

  )

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.logoSection}>
          <div style={styles.logoCircle}>L</div>
          <span style={{ fontWeight: '600' }}>Lions Clubs</span>
        </div>
       <div style={{ display: 'flex', gap: '15px' }}>


  <User
    size={22}
    style={{ cursor: 'pointer' }}
    onClick={() => {
      const isLoggedIn = sessionStorage.getItem('loginMobile');

      if (!isLoggedIn) {
        setView('LOGIN');
      } else {
        console.log('Navigate to Profile');
       
       setView('PROFILE')
      }
    }}
  />
</div>
      </div>



       {view === 'HOME' && <HomeView />}
 {(view === 'LOGIN' || view === 'VERIFY') && (
  <AuthScreen
    view={view}
    setView={setView}
    mobileNumber={mobileNumber}
    setMobileNumber={setMobileNumber}
    otp={otp}
    setOtp={setOtp}
    handleSendOTP={handleSendOTP}
    handleVerifyOTP={handleVerifyOTP}
    loadingSendOtp={loadingSendOtp}
    loadingVerifyOtp={loadingVerifyOtp}
    resendTimer={resendTimer}
    styles={styles}
  />
)}

        {view === 'CLUBS' && (
      <ClubsList 
        styles={styles} 
        onBack={() => setView('HOME')} 
        onSelectClub={(club) => {
          setSelectedClub(club);
          setView('DETAILS');
        }} 
      />
    )}

    {view === 'DETAILS' && (
      <ClubDetails 
        club={selectedClub} 
        styles={styles} 
        onBack={() => setView('CLUBS')} 
      />
    )}

{view === 'MEMBERS_CLUBS' && (
  <ClubsList 
    styles={styles} 
    onBack={() => setView('HOME')} 
    title="Select Club" // Pass a prop to change the header text to "Select Club"
    onSelectClub={(club) => {
      setSelectedClub(club);
      setView('MEMBERS_LIST');
    }} 
  />
)}

{view === 'MEMBERS_LIST' && (
  <MembersList 
    clubName={selectedClub?.clubName} 
    styles={styles} 
    onBack={() => setView('MEMBERS_CLUBS')} 
  />
)}

      {view === 'International_LIST' && <InternationaltList styles={styles} onBack={() => setView('HOME')} onSelectItem={(cat) => { setSelectedCategory(cat); setView('International_MEMBERS'); }} />}
      {view === 'International_MEMBERS' && <InternationalMembers categoryName={selectedCategory} styles={styles} onBack={() => setView('International_LIST')} />}
      

{view === 'DISTRICT_LIST' && (
  <DistrictList 
    styles={styles} 
    onBack={() => setView('HOME')} 
    onSelectItem={(cat) => {
      setSelectedCategory(cat);
      setView('DISTRICT_MEMBERS');
    }} 
  />
)}

{view === 'DISTRICT_MEMBERS' && (
  <DistrictMembers 
    categoryName={selectedCategory} 
    styles={styles} 
    onBack={() => setView('DISTRICT_LIST')} 
  />
)}

{view === 'BAMA_LIST' && (
  <BAMAList 
    styles={styles} 
    onBack={() => setView('HOME')} 
  />
)}

{view === 'PROFILE' && (
  <ProfilePage 
    styles={styles} 
    onBack={() => setView('HOME')} 
    onLogout={() => {
      sessionStorage.clear();
      setView('AUTH');
    }}
  />
)}


{view === 'MultipleDgWeb' && (
  <MultipleDgWeb 
    styles={styles} 
    onBack={() => setView('HOME')} 
   
  />
)}

{view === 'DOLLAR_RATE' && (
  <DollarRate 
    styles={styles} 
    onBack={() => setView('HOME')} 
  />
)}

{view === 'DG_DIARY' && (
  <DGDiaryWeb 
    styles={styles} 
    onBack={() => setView('HOME')} 
  />
)}


{view === 'EVENTS' && (
  <EventsWeb 
    styles={styles} 
    onBack={() => setView('HOME')} 
  />
)}

{view === 'CONTACT' && (
  <ContactWeb 
    styles={styles} 
    onBack={() => setView('HOME')} 
  />
)}

{view === 'NOTIFICATIONS' && (
  <NotificationWeb
    styles={styles} 
    onBack={() => setView('HOME')} 
  />
)}


{view === 'CAMERA' && (
  <CameraView 
    styles={styles} 
    onBack={() => setView('HOME')} 
    onCapture={(imageFile) => {
      setCapturedImage(imageFile);
      setView('CAMERA_DETAILS');
    }}
  />
)}

{view === 'CAMERA_DETAILS' && (
  <ActivityDetails
    styles={styles}
    image={capturedImage}
    onBack={() => setView('CAMERA')}
    onSave={handleUpload}
  />
)}


{view === 'GALLERY' && (
  <ActivityGallery 
    styles={styles} 
    onBack={() => setView('HOME')} 
    onSelectImage={(img) => {
      setSelectedImage(img);
      setView('GALLERY_DETAIL');
    }}
  />
)}

{view === 'GALLERY_DETAIL' && (
  <GalleryDetail 
    image={selectedImage} 
    styles={styles} 
    onBack={() => setView('GALLERY')} 
  />
)}
      {/* Bottom Nav */}
      <div style={styles.bottomNav}>
        <div style={{ ...styles.navItem, color: '#0033A0' }}>
          <Home size={22} />
          <span>Home</span>
        </div>
        <div style={styles.navItem}  onClick={() => setView('CAMERA')}>
          <Camera size={22} />
          <span>Camera</span>
        </div>
        <div style={styles.navItem}   onClick={() => setView('GALLERY')}>
          <Image size={22} />
          <span>Gallery</span>
        </div>
        <div style={styles.navItem} onClick={()=> setView('NOTIFICATIONS')}>
          <Bell size={22} style={{ cursor: 'pointer' }} />
          <span>Notifications</span>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;